export default {
  en: {
    forgotpassword: {
      heading: 'Forgot Password',
      request: {
        text: 'Losing a password happens, reset it right now!',
        button: 'E-Mail reset link',
        hasbeensent: 'If account exists for "{email}", an email with instructions was sent.',
      },
      verified: {
        text: 'You are verified! Please enter a new password.',
        button: 'Set new password',
        newpasswordlabel: 'New password',
        placeholder: 't0pSecret1234',
        newpasswordlabelconfirmed: 'Password confirmed',
        successreset: 'Password was reset. Please login with new password.',
      },
      foundagain: 'Found it again?',
      donthaveacc: "Don't have an account?",
    }
  },
  de: {
    forgotpassword: {
      heading: 'Passwort vergessen',
      request: {
        text: 'Passwort vergessen? Kein Problem, setze es jetzt zurück!',
        button: 'E-Mail zum Zurücksetzen senden',
        hasbeensent: 'Falls ein Account für "{email}" existiert, wurde eine E-Mail mit Anweisungen gesendet.',
      },
      verified: {
        text: 'Du bist verifiziert! Bitte gib ein neues Passwort ein.',
        button: 'Neues Passwort setzen',
        newpasswordlabel: 'Neues Passwort',
        placeholder: 't0pSecret1234',
        newpasswordlabelconfirmed: 'Passwort bestätigen',
        successreset: 'Das Passwort wurde zurückgesetzt. Bitte melde dich mit dem neuen Passwort an.',
      },
      foundagain: 'Schon wieder gefunden?',
      donthaveacc: 'Noch keinen Account?',
    }
  },
  es: {
    forgotpassword: {
      heading: 'Olvidé mi contraseña',
      request: {
        text: '¿Olvidaste tu contraseña? No hay problema, ¡restablécela ahora!',
        button: 'Enviar correo electrónico para restablecer',
        hasbeensent: 'Si existe una cuenta para "{email}", se ha enviado un correo electrónico con instrucciones.',
      },
      verified: {
        text: '¡Estás verificado! Por favor, ingresa una nueva contraseña.',
        button: 'Establecer nueva contraseña',
        newpasswordlabel: 'Nueva contraseña',
        placeholder: 't0pSecret1234',
        newpasswordlabelconfirmed: 'Confirmar contraseña',
        successreset: 'La contraseña ha sido restablecida. Por favor, inicia sesión con la nueva contraseña.',
      },
      foundagain: '¿La encontraste de nuevo?',
      donthaveacc: '¿No tienes una cuenta?',
    }
  },
  uk: {
    forgotpassword: {
      heading: 'Забули пароль',
      request: {
        text: 'Забули пароль? Не проблема, скиньте його зараз!',
        button: 'Відправити лист для скидання',
        hasbeensent: 'Якщо існує акаунт для "{email}", на нього було надіслано лист з інструкціями.',
      },
      verified: {
        text: 'Ви підтверджені! Будь ласка, введіть новий пароль.',
        button: 'Встановити новий пароль',
        newpasswordlabel: 'Новий пароль',
        placeholder: 't0pSecret1234',
        newpasswordlabelconfirmed: 'Підтвердити пароль',
        successreset: 'Пароль було скинуто. Будь ласка, увійдіть з новим паролем.',
      },
      foundagain: 'Знайшли знову?',
      donthaveacc: 'Немає акаунту?',
    }
  }
}
